// extracted by mini-css-extract-plugin
module.exports =  {"miss":"maturityLevel__miss","title":"maturityLevel__title","progress":"maturityLevel__progress","progress-text":"maturityLevel__progress-text"};